import { NgModule } from "@angular/core";
import { QuillModule } from "ngx-quill";
import Quill from 'quill';


const Size = Quill.import("attributors/style/size") as any;
const Align = Quill.import("attributors/style/align") as any;
const BlockEmbed = Quill.import('blots/block/embed') as any;

// Custom Page Break Blot
class PageBreakBlot extends BlockEmbed {
  static blotName = 'pageBreak';
  static tagName = 'div';
  static className = 'page-break';

  static create() {
    const node = super.create();
    node.setAttribute('contenteditable', 'false');
    node.setAttribute('style', 'page-break-after: always; page-break-inside: avoid; break-after: page; display: block; height: 0; clear: both;');
    return node;
  }
}

Size.whitelist = [
  false,
  "9px",
  "10px",
  "11px",
  "12px",
  "14px",
  "16px",
  "18px",
  "20px",
  "22px",
  "24px",
  "26px",
  "28px",
];
Quill.register(Size, true);
Quill.register(Align, true);
Quill.register(PageBreakBlot); // Register the page break blot

const modules = {
  // No `syntax`/highlight.js: there is no code-block toolbar button, so it only
  // added ~1 MB (all languages) to the initial bundle for nothing.
  toolbar: {
    container: [
    ["bold", "italic", "underline", "strike"], // toggled buttons
    //["blockquote", "code-block"],
    [{ header: 1 }, { header: 2 }], // custom button values
    [{ list: "ordered" }, { list: "bullet" }],
    //[{ script: "sub" }, { script: "super" }], // superscript/subscript
    [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
    //[{ direction: "rtl" }], // text direction
    [{ size: [false,'9px','10px','11px','12px','14px','16px','18px','20px','22px','24px','26px','28px']}], // custom dropdown
    //[{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ color: [] }, { background: [] }], // dropdown with defaults from theme
    //[{ font: [] }],
    [{ align: [] }],
    ["clean"], // remove formatting button
    ["link"], //["link", "image", "video"], // link and image, video
    ["page-break"] // Add page break button
  ],
  handlers: {
      'page-break': function(this: { quill: Quill }) {
        const range = this.quill.getSelection(true);
        this.quill.insertEmbed(range.index, 'pageBreak', true, Quill.sources.USER);
        this.quill.setSelection(range.index + 1, Quill.sources.SILENT);
      }
    }
  },
  keyboard: {
    bindings: {
      tab: {
        key: 9,
        handler: function(this: { quill: Quill }, range: any) {
          this.quill.insertText(range.index, '\t');
          this.quill.setSelection(range.index + 1);
          return false;
        }
      }
    }
  }
};


@NgModule({
  imports: [
    QuillModule.forRoot({modules}),
  ],
  exports: [
    QuillModule,
  ]
})
export class QuillEditorModule { }